import styled from "styled-components";

export default styled.div`
    .title-container {
        display: flex;
        justify-content: space-between;

        .page-title {
            font-size: 30px;
            color: ${(props) => props.theme.pageTitleText};
            letter-spacing: 1.7px;
            font-weight: 400;
            display: flex;
            flex-direction: row;
            width: 90%;
        }

        .left-container,
        .right-container {
            width: 50%;
            display: flex;
            align-items: center;
            margin: 20px 0 10px 0;
        }

        .right-container {
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 10px;

            .button {
                margin: 0;
            }
        }
    }

    .details {
        display: flex;
        flex-direction: row;

        .detail {
            display: flex;
            flex-direction: row;
            align-items: center;

            p {
                color: ${(props) => props.theme.homeListRowText};
                font-size: 14px;
            }

            svg {
                color: ${(props) => props.theme.homeListRowText};
                font-size: 10px;
                margin-right: 4px;
                margin-bottom: 2px;
            }
        }
    }

    .morning-notes {
        margin-top: 40px;
    }

    hr {
        width: calc(100% - 10px);
        outline: none;
        border: none;
        margin: 0 5px;
        border-bottom: 1px solid #efefef;
    }

    .loadingScreen {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-grow: 1;

        svg {
            font-size: 60px;
        }
    }
`;
